'use strict';
var parent = require('../../actual/instance/sort');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/sort.js
// module id = 627
// module chunks = 13